import Bugsnag from '@bugsnag/js';
import isString from 'lodash/isString';
import { Md5 } from 'ts-md5';
import { requestUrlsWithUniqueIds } from './requestUrlsWithUniqueIds';

interface IOptions {
  context: string;
  metadata?;
  severity?: 'error' | 'info' | 'warning';
}

interface ErrorWithResponse {
  response?: {
    isPotentialBot?: boolean;
    [key: string]: any;
  };
}

function hasResponse(error: any): error is ErrorWithResponse {
  return error && typeof error === 'object' && 'response' in error;
}

// https://docs.bugsnag.com/platforms/javascript/reporting-handled-errors/#customizing-diagnostic-data
// TODO: fix the method signature here. The actual Bugsnag.notify() is variadic and accepts
// a variety of different inputs  e.g. (Error, null, Function) ... (Error, Function) ...
export const bugsnag = (error: string | Error, options?: IOptions) => {
  // Don't send bot-related errors to Bugsnag to save on event quota
  if (hasResponse(error) && error.response?.isPotentialBot) {
    return;
  }

  // no need to send aborted requests to bugsnag $$$
  if (typeof error === 'string' || error?.message !== 'Request aborted') {
    Bugsnag.notify(isString(error) ? new Error(error) : error, (event) => {
      event.severity = options.severity || 'error';
      event.context = options.context;

      if (options.metadata) {
        event.addMetadata(options.context, options.metadata);
        if (!requestUrlsWithUniqueIds.some((url) => options.metadata?.url.includes(url))) {
          event.groupingHash = Md5.hashStr(
            `${options.metadata?.errorCode as number}-${options.metadata?.url as string}`,
          );
        }
      }
    });
  }
};
